import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteListItem,
  addOrAddAllProductToCart,
  productMarkUncompleted,
  getCartList,
  productMarkCompleteAll,
} from "redux/actions";
import { getLocalStorageValue } from 'config/helper';
import { useGotoLogin } from 'hooks/useGotoLogin';
import { useNavigate } from 'react-router-dom';
import { useGetListDetails } from 'hooks/useGetListDetails';

const ListProduct = ({ product, list_id, isCompletedGrid }) => {
  const { image, name, qty = 1, price, department_name, product_id, custom_options_arr = "", is_available, wishlist_product_id } = product;
  const customOptions = getCustomOptions(custom_options_arr)
  
  const gotoLogin = useGotoLogin();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentStoreID } = useSelector(({ store }) => store);
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const {
    ecom_section: { allow_ecommerce = "" },
    header_section: { allow_ecom_cart_and_checkout = "" },
  } = useSelector(({ common }) => common.commonDetailsData);

  const clientId = getLocalStorageValue("RSAclient-id");
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const { refetchListDetails } = useGetListDetails();

  const handleRemoveProductFromList = () => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      list_id: list_id,
      product_id: product_id !== "0" ? product_id : wishlist_product_id,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    dispatch(deleteListItem(body, () => refetchListDetails()));
  };

  function updateProductQty(qty) {
    if (isCompletedGrid) {
      handleProductComplete(product_id, qty);
    } else {
      handleProductUncomplete(product_id, qty);
    }
  }

  const handleIncrementCount = () => {
    updateProductQty(+qty + 1);
  }

  const handleDecrementCount = () => {
    if (qty > 1) {
      updateProductQty(+qty - 1);
    }
  };

  const handleAddToCart = (product_id, qty) => {
    if (+product?.is_mealkit > 0) {
      navigate(`/catering-product-description/${product.department_slug}/${product.slug}`)
      return
    }

    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      items_data: [{ product_id, qty }],
      list_id: list_id,
    };

    isUserLoggedIn &&
      dispatch(addOrAddAllProductToCart(body)).then((res) => {
        const body = {
          RSAClientId: clientId,
          ClientStoreId: +storeId || 1,
          AppName: "shop",
          member_number: memberNumber,
          user_token: userToken,
          Version: "1",
          DeviceType: "web",
        };
        isUserLoggedIn && dispatch(getCartList(body));
      });
  };

  const handleProductComplete = (product_id, qty) => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      list_id: list_id,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      items_data: [{ product_id, qty }],
    };
    dispatch(productMarkCompleteAll(body));
  };

  const handleProductUncomplete = (product_id, qty) => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      list_id: list_id,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      items_data: [{ product_id, qty }],
    };

    isUserLoggedIn && dispatch(productMarkUncompleted(body));
  };

  const isUnavailable = is_available === "0";

  return (
    <div className={`cart-items-list-view-section ${isUnavailable ? 'item-unavailable' : ''}`} key={product_id}>
      {isUnavailable && (
        <div className="unavailable-badge">
          <i className="fa-solid fa-circle-exclamation"></i>
          <span>Unavailable</span>
        </div>
      )}
      <div className="sub-grid">
        <div className="sub-grid-items">
          <div className="product-view-grid">
            <div className="product-view-grid-items">
              <div className="product-image-show">
                <img src={image} alt="ProductImage" />
              </div>
            </div>
            <div className="product-view-grid-items">
              <h6>{name}</h6>
              {!isUnavailable && (
                <>
                  {isCompletedGrid ? (
                    <div className="add-mark-section">
                      <div className="add-to-cart">
                        <button onClick={() => handleProductUncomplete(product_id, qty)}>
                          <span>Uncomplete</span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="add-mark-section">
                      {allow_ecommerce === "1" && allow_ecom_cart_and_checkout === "1" && (
                        <div className="add-to-cart">
                          <button onClick={() => handleAddToCart(product_id, qty)}>
                            <span>Add To Cart</span>
                          </button>
                        </div>
                      )}

                      <div className="add-to-cart">
                        <button
                          onClick={() => handleProductComplete(product_id, qty)}
                        >
                          <span>Mark as Completed</span>
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="all-action-alignment">
          <div className="quantity-button" style={isUnavailable ? { visibility: 'hidden' } : {}}>
            <button>
              <span>{qty}</span>
              <div className="arrow-alignment">
                <div onClick={handleIncrementCount}>
                  <i className="fa-solid fa-angle-up"></i>
                </div>
                <div onClick={handleDecrementCount}>
                  <i className="fa-solid fa-angle-down"></i>
                </div>
              </div>
            </button>
          </div>
          <div className="price-count" style={isUnavailable ? { visibility: 'hidden' } : {}}>
            {price > 0 && (
              <h6>{`$${price}`}</h6>
            )}
            {price === 0 && (
              <p style={{ color: 'red' }}>Not Available</p>
            )}
          </div>
          <div className="product-view-grid-items" style={isUnavailable ? { visibility: 'hidden' } : {}}>
            <h6>{department_name}</h6>
          </div>
          <div
            className="remove-icon"
            onClick={() => handleRemoveProductFromList()}
          >
            <i className="fa-solid fa-trash-can"></i>
          </div>
        </div>
      </div>
      {customOptions?.length ? (
        <div className="custom-options-section">
          {customOptions.map((option, index) => (
            <div key={index} className="custom-option-item">
              <span className="custom-option-label">{option.label}:</span>
              <span className="custom-option-value">{option.value}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

function getCustomOptions(custom_options_arr) {
  let customOptions;
  try {
    customOptions = JSON.parse(custom_options_arr);
  } catch {
    return [];
  }
  if (Array.isArray(customOptions)) {
    return customOptions;
  }
  return [];
}

export default ListProduct;
